<template lang="pug">
div
  .pa-2.mx-1.my-10
    v-row.my-10(justify="center")
      div.text-h5 How could an EV change your life?
    v-row(justify="center")
      v-col(cols=7, lg=3)
        v-row(justify="center")
          v-card.pa-2.mx-1.pb-10(v-on:click="drivingDetails", width="280px")
            p Find your ideal EV and its running costs
            v-img(
              src="https://powersell.appstack.me/icons/eco_car.svg",
              height=80,
              width=80,
              v-bind:class="{ white: $vuetify.theme.dark }"
            )
      v-col(cols=7, lg=3)
        v-row(justify="center")
          v-card.pa-2.mx-1.pb-10(v-on:click="routePlanning", width="280px")
            p Find charging stations and plan a road trip
            v-img(
              src="https://powersell.appstack.me/icons/station_pin.svg",
              height=80,
              width=80,
              v-bind:class="{ white: $vuetify.theme.dark }"
            )

    v-row(align="center", justify="end")
      v-col(cols=3)
        v-spacer
        em(style="font-size: 0.8em;margin-left:5px;") Powered by
        v-img(src="https://powersell.appstack.me/logo.png", width=100)
</template>

<script>
import Vue from 'vue';
export default {
  mounted() {
    if (this.$route.query.state) {
      let state = this.$route.query.state;
      let loadState = this.loadState;
      setTimeout(function () {
        loadState(state);
      }, 1000);
    }
    Vue.prototype.$Countly.q.push([
      "add_event",
      {
        key: "Default Landing Page",
        segmentation: {
          dealer: this.$dealer.default_settings.name,
        },
      },
    ]);
  },
  methods: {
    drivingDetails() {
      this.$router.push("recommender/0");
    },
    routePlanning() {
      this.$router.push("planner");
    },
    regularTrips() {
      this.$router.push("recommender/1");
    },
    dealerAdmin() {
      this.$router.push("dealer");
    },
  },
};
</script>

<style scoped>
.v-card > h2,
.subtitle {
  color: #1E88E5;
  font-weight: bold;
}
a {
  text-decoration: none;
}
.right {
  float: right;
}
.v-card p {
  text-align: center;
}
.v-card .v-image {
  transform: translate(-50%, 0);
  left: 50%;
  opacity: 0.6;
}
.icon-image {
  opacity: 0.5;
  float: right;
}
.white {
  filter: invert(1);
  mix-blend-mode: lighten;
}
</style>